module.exports = __webpack_public_path__ + "static/media/icon_level3.a1b8c912.svg";